import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
  BussinessErrorLocalType,
  REPO_API,
} from '../Core';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/utils/countries';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';
const URL_POSTMAN_VERSION =
  '?version=87b99701-836d-44ab-85db-b954a0714e81&tab=overview';
export const URL_POSTMAN = `${REPO_API}/Conta~1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/2147c694-c683-4d21-aa2d-e7490939aa7c${URL_POSTMAN_VERSION}`;

export const CODE_ERRORS: ErrorResponseCodeType<BussinessErrorLocalType>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '3',
    bussinessErrorVariant: 'countryNotFound',
    message: 'Pais não encontrado.',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = async (params?: {
  country?: string;
  iso2?: string;
  iso3?: string;
  ddi?: string;
}): Promise<IFinalResponse> => {
  const init: InitApiType = {};

  if (params) {
    init.params = {};

    if (params.country) {
      init.params.country = params.country;
    }
    if (params.iso2) {
      init.params.iso2 = params.iso2;
    }
    if (params.iso3) {
      init.params.iso3 = params.iso3;
    }
    if (params.ddi) {
      init.params.ddi = params.ddi;
    }
  }

  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const call = { get: callGet };

export default { call, definitions };
